import styled from 'styled-components';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const TextHighlight = styled.div`
  width: 100%;
  height: 100%;
  z-index: -999999999999;
  ${withModifiers('$isSelected')`
    background-color: ${color.brand.gold}  
  `}
`;
